import { render } from "./VacanciesView.vue?vue&type=template&id=7cd85542&scoped=true"
import script from "./VacanciesView.vue?vue&type=script&lang=js"
export * from "./VacanciesView.vue?vue&type=script&lang=js"

import "./VacanciesView.vue?vue&type=style&index=0&id=7cd85542&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd85542"]])

export default __exports__